import {
  FALL_CRAWL_ANALYTICS_ACTIONS,
  FALL_CRAWL_ANALYTICS_FEATURE,
} from "../../utils/publicVisitorAnalytics";

const FALL_CRAWL_EVENT_LABEL = "Fall Crawl 2026";

const sanitizeAnalyticsLabel = (value = "", maxLength = 80) =>
  String(value || "").trim().slice(0, maxLength);

export const trackFallCrawlInteraction = (action, {
  eventId = "",
  stopId = "",
  stopName = "",
  label = "",
  allowRepeat = false,
} = {}) => {
  if (!Object.values(FALL_CRAWL_ANALYTICS_ACTIONS).includes(action)) return false;
  let trackUsageEvent;
  try {
    ({ trackUsageEvent } = require("./CampaignTrafficTracker"));
  } catch {
    return false;
  }

  return trackUsageEvent("event_participation_intent", {
    feature: FALL_CRAWL_ANALYTICS_FEATURE,
    action,
    relatedId: sanitizeAnalyticsLabel(stopId || eventId || "fall-crawl-2026", 120),
    routeName: sanitizeAnalyticsLabel(stopName || label || FALL_CRAWL_EVENT_LABEL, 80),
    allowRepeat,
  });
};
